export type CountryType = {
    code: string
    label: string
}

export const countries: readonly CountryType[] = [
    { code: 'AD', label: 'Andorra' },
    { code: 'AE', label: 'الإمارات العربية المتحدة' }, // United Arab Emirates in Arabic
    { code: 'AF', label: 'افغانستان' }, // Afghanistan in Dari/Pashto
    { code: 'AG', label: 'Antigua and Barbuda' },
    { code: 'AI', label: 'Anguilla' },
    { code: 'AL', label: 'Shqipëri' }, // Albania in Albanian
    { code: 'AM', label: 'Հայաստան' }, // Armenia in Armenian
    { code: 'AO', label: 'Angola' },
    { code: 'AQ', label: 'Antarctica' },
    { code: 'AR', label: 'Argentina' },
    { code: 'AS', label: 'American Samoa' },
    { code: 'AT', label: 'Österreich' }, // Austria in German
    { code: 'AU', label: 'Australia' },
    { code: 'AW', label: 'Aruba' },
    { code: 'AX', label: 'Åland Islands' },
    { code: 'AZ', label: 'Azərbaycan' }, // Azerbaijan in Azerbaijani
    { code: 'BA', label: 'Bosna i Hercegovina' }, // Bosnia and Herzegovina in Bosnian
    { code: 'BB', label: 'Barbados' },
    { code: 'BD', label: 'বাংলাদেশ' }, // Bangladesh in Bengali
    { code: 'BE', label: 'Belgique' }, // Belgium in Dutch
    { code: 'BF', label: 'Burkina Faso' },
    { code: 'BG', label: 'България' }, // Bulgaria in Bulgarian
    { code: 'BH', label: 'البحرين' }, // Bahrain in Arabic
    { code: 'BI', label: 'Burundi' },
    { code: 'BJ', label: 'Bénin' }, // Benin in French
    { code: 'BL', label: 'Saint-Barthélemy' }, // Saint Barthélemy in French
    { code: 'BM', label: 'Bermuda' },
    { code: 'BN', label: 'Brunei Darussalam' },
    { code: 'BO', label: 'Bolivia' },
    { code: 'BR', label: 'Brasil' }, // Brazil in Portuguese
    { code: 'BS', label: 'Bahamas' },
    { code: 'BT', label: 'འབྲུག' }, // Bhutan in Dzongkha
    { code: 'BW', label: 'Botswana' },
    { code: 'BY', label: 'Беларусь' }, // Belarus in Belarusian
    { code: 'BZ', label: 'Belize' },
    { code: 'CA', label: 'Canada' },
    { code: 'CC', label: 'Cocos (Keeling) Islands' },
    { code: 'CD', label: 'République démocratique du Congo' }, // Democratic Republic of the Congo in French
    { code: 'CF', label: 'République centrafricaine' }, // Central African Republic in French
    { code: 'CG', label: 'République du Congo' }, // Republic of the Congo in French
    { code: 'CH', label: 'Suisse' }, // Switzerland in German
    { code: 'CI', label: 'Côte d’Ivoire' }, // Ivory Coast in French
    { code: 'CK', label: 'Cook Islands' },
    { code: 'CL', label: 'Chile' },
    { code: 'CM', label: 'Cameroun' }, // Cameroon in French
    { code: 'CN', label: '中国' }, // China in Chinese
    { code: 'CO', label: 'Colombia' },
    { code: 'CR', label: 'Costa Rica' },
    { code: 'CU', label: 'Cuba' },
    { code: 'CV', label: 'Cabo Verde' }, // Cape Verde in Portuguese
    { code: 'CW', label: 'Curaçao' },
    { code: 'CX', label: 'Christmas Island' },
    { code: 'CY', label: 'Κύπρος' }, // Cyprus in Greek
    { code: 'CZ', label: 'Česká republika' }, // Czech Republic in Czech
    { code: 'DE', label: 'Deutschland' }, // Germany in German
    { code: 'DJ', label: 'Djibouti' },
    { code: 'DK', label: 'Danmark' }, // Denmark in Danish
    { code: 'DM', label: 'Dominica' },
    { code: 'DO', label: 'República Dominicana' }, // Dominican Republic in Spanish
    { code: 'DZ', label: 'الجزائر' }, // Algeria in Arabic
    { code: 'EC', label: 'Ecuador' },
    { code: 'EE', label: 'Eesti' }, // Estonia in Estonian
    { code: 'EG', label: 'مصر' }, // Egypt in Arabic
    { code: 'EH', label: 'الصحراء الغربية' }, // Western Sahara in Arabic
    { code: 'ER', label: 'ኤርትራ' }, // Eritrea in Tigrinya
    { code: 'ES', label: 'España' }, // Spain in Spanish
    { code: 'ET', label: 'ኢትዮጵያ' }, // Ethiopia in Amharic
    { code: 'FI', label: 'Suomi' }, // Finland in Finnish
    { code: 'FJ', label: 'Fiji' },
    { code: 'FK', label: 'Islas Malvinas' }, // Falkland Islands in Spanish
    { code: 'FM', label: 'Micronesia' },
    { code: 'FO', label: 'Føroyar' }, // Faroe Islands in Faroese
    { code: 'FR', label: 'France' },
    { code: 'GA', label: 'Gabon' },
    { code: 'GB', label: 'United Kingdom' },
    { code: 'GD', label: 'Grenada' },
    { code: 'GE', label: 'საქართველო' }, // Georgia in Georgian
    { code: 'GF', label: 'Guyane française' }, // French Guiana in French
    { code: 'GG', label: 'Guernsey' },
    { code: 'GH', label: 'Ghana' },
    { code: 'GI', label: 'Gibraltar' },
    { code: 'GL', label: 'Kalaallit Nunaat' }, // Greenland in Greenlandic
    { code: 'GM', label: 'Gambia' },
    { code: 'GN', label: 'Guinée' }, // Guinea in French
    { code: 'GP', label: 'Guadeloupe' },
    { code: 'GQ', label: 'Guinea Ecuatorial' }, // Equatorial Guinea in Spanish
    { code: 'GR', label: 'Ελλάδα' }, // Greece in Greek
    { code: 'GS', label: 'South Georgia and the South Sandwich Islands' },
    { code: 'GT', label: 'Guatemala' },
    { code: 'GU', label: 'Guam' },
    { code: 'GW', label: 'Guiné-Bissau' }, // Guinea-Bissau in Portuguese
    { code: 'GY', label: 'Guyana' },
    { code: 'HK', label: '香港' }, // Hong Kong in Chinese
    { code: 'HN', label: 'Honduras' },
    { code: 'HR', label: 'Hrvatska' }, // Croatia in Croatian
    { code: 'HT', label: 'Haïti' }, // Haiti in French
    { code: 'HU', label: 'Magyarország' }, // Hungary in Hungarian
    { code: 'ID', label: 'Indonesia' },
    { code: 'IE', label: 'Éire' }, // Ireland in Irish
    { code: 'IL', label: 'ישראל' }, // Israel in Hebrew
    { code: 'IM', label: 'Isle of Man' },
    { code: 'IN', label: 'भारत' }, // India in Hindi
    { code: 'IQ', label: 'العراق' }, // Iraq in Arabic
    { code: 'IR', label: 'ایران' }, // Iran in Persian
    { code: 'IS', label: 'Ísland' }, // Iceland in Icelandic
    { code: 'IT', label: 'Italia' }, // Italy in Italian
    { code: 'JE', label: 'Jersey' },
    { code: 'JM', label: 'Jamaica' },
    { code: 'JO', label: 'الأردن' }, // Jordan in Arabic
    { code: 'JP', label: '日本' }, // Japan in Japanese
    { code: 'KE', label: 'Kenya' },
    { code: 'KG', label: 'Кыргызстан' }, // Kyrgyzstan in Kyrgyz
    { code: 'KH', label: 'កម្ពុជា' }, // Cambodia in Khmer
    { code: 'KI', label: 'Kiribati' },
    { code: 'KM', label: 'جزر القمر' }, // Comoros in Arabic
    { code: 'KN', label: 'Saint Kitts and Nevis' },
    { code: 'KP', label: '조선민주주의인민공화국' }, // North Korea in Korean
    { code: 'KR', label: '대한민국' }, // South Korea in Korean
    { code: 'KW', label: 'الكويت' }, // Kuwait in Arabic
    { code: 'KY', label: 'Cayman Islands' },
    { code: 'KZ', label: 'Қазақстан' }, // Kazakhstan in Kazakh
    { code: 'LA', label: 'ລາວ' }, // Laos in Lao
    { code: 'LB', label: 'لبنان' }, // Lebanon in Arabic
    { code: 'LC', label: 'Saint Lucia' },
    { code: 'LI', label: 'Liechtenstein' },
    { code: 'LK', label: 'ශ්‍රී ලංකාව' }, // Sri Lanka in Sinhala
    { code: 'LR', label: 'Liberia' },
    { code: 'LS', label: 'Lesotho' },
    { code: 'LT', label: 'Lietuva' }, // Lithuania in Lithuanian
    { code: 'LU', label: 'Lëtzebuerg' }, // Luxembourg in Luxembourgish
    { code: 'LV', label: 'Latvija' }, // Latvia in Latvian
    { code: 'LY', label: 'ليبيا' }, // Libya in Arabic
    { code: 'MA', label: 'المغرب' }, // Morocco in Arabic
    { code: 'MC', label: 'Monaco' },
    { code: 'MD', label: 'Moldova' },
    { code: 'ME', label: 'Crna Gora' }, // Montenegro in Montenegrin
    { code: 'MF', label: 'Saint-Martin' }, // Saint Martin in French
    { code: 'MG', label: 'Madagasikara' }, // Madagascar in Malagasy
    { code: 'MH', label: 'M̧ajeļ' }, // Marshall Islands in Marshallese
    { code: 'MK', label: 'Македонија' }, // Macedonia in Macedonian
    { code: 'ML', label: 'Mali' },
    { code: 'MM', label: 'မြန်မာ' }, // Myanmar in Burmese
    { code: 'MN', label: 'Монгол' }, // Mongolia in Mongolian
    { code: 'MO', label: '澳門' }, // Macao in Chinese
    { code: 'MP', label: 'Northern Mariana Islands' },
    { code: 'MQ', label: 'Martinique' },
    { code: 'MR', label: 'موريتانيا' }, // Mauritania in Arabic
    { code: 'MS', label: 'Montserrat' },
    { code: 'MT', label: 'Malta' },
    { code: 'MU', label: 'Moris' }, // Mauritius in Mauritian Creole
    { code: 'MV', label: 'ދިވެހިރާއްޖޭގެ' }, // Maldives in Dhivehi
    { code: 'MW', label: 'Malawi' },
    { code: 'MX', label: 'México' }, // Mexico in Spanish
    { code: 'MY', label: 'Malaysia' },
    { code: 'MZ', label: 'Moçambique' }, // Mozambique in Portuguese
    { code: 'NA', label: 'Namibia' },
    { code: 'NC', label: 'Nouvelle-Calédonie' }, // New Caledonia in French
    { code: 'NE', label: 'Niger' },
    { code: 'NF', label: 'Norfolk Island' },
    { code: 'NG', label: 'Nigeria' },
    { code: 'NI', label: 'Nicaragua' },
    { code: 'NL', label: 'Nederland' }, // Netherlands in Dutch
    { code: 'NO', label: 'Norge' }, // Norway in Norwegian
    { code: 'NP', label: 'नेपाल' }, // Nepal in Nepali
    { code: 'NR', label: 'Nauru' },
    { code: 'NU', label: 'Niue' },
    { code: 'NZ', label: 'Aotearoa' }, // New Zealand in Maori
    { code: 'OM', label: 'عمان' }, // Oman in Arabic
    { code: 'PA', label: 'Panamá' }, // Panama in Spanish
    { code: 'PE', label: 'Perú' }, // Peru in Spanish
    { code: 'PF', label: 'Polynésie française' }, // French Polynesia in French
    { code: 'PG', label: 'Papua Niugini' }, // Papua New Guinea in Tok Pisin
    { code: 'PH', label: 'Pilipinas' }, // Philippines in Filipino
    { code: 'PK', label: 'پاکستان' }, // Pakistan in Urdu
    { code: 'PL', label: 'Polska' }, // Poland in Polish
    { code: 'PM', label: 'Saint-Pierre-et-Miquelon' }, // Saint Pierre and Miquelon in French
    { code: 'PN', label: 'Pitcairn Islands' },
    { code: 'PR', label: 'Puerto Rico' },
    { code: 'PS', label: 'فلسطين' }, // Palestine in Arabic
    { code: 'PT', label: 'Portugal' },
    { code: 'PW', label: 'Belau' }, // Palau in Palauan
    { code: 'PY', label: 'Paraguay' },
    { code: 'QA', label: 'قطر' }, // Qatar in Arabic
    { code: 'RE', label: 'La Réunion' }, // Reunion in French
    { code: 'RO', label: 'România' }, // Romania in Romanian
    { code: 'RS', label: 'Србија' }, // Serbia in Serbian
    { code: 'RU', label: 'Россия' }, // Russia in Russian
    { code: 'RW', label: 'Rwanda' },
    { code: 'SA', label: 'السعودية' }, // Saudi Arabia in Arabic
    { code: 'SB', label: 'Solomon Islands' },
    { code: 'SC', label: 'Sesel' }, // Seychelles in Seychellois Creole
    { code: 'SD', label: 'السودان' }, // Sudan in Arabic
    { code: 'SE', label: 'Sverige' }, // Sweden in Swedish
    { code: 'SG', label: 'Singapura' }, // Singapore in Malay
    { code: 'SH', label: 'Saint Helena' },
    { code: 'SI', label: 'Slovenija' }, // Slovenia in Slovenian
    { code: 'SJ', label: 'Svalbard og Jan Mayen' }, // Svalbard and Jan Mayen in Norwegian
    { code: 'SK', label: 'Slovensko' }, // Slovakia in Slovak
    { code: 'SL', label: 'Sierra Leone' },
    { code: 'SM', label: 'San Marino' },
    { code: 'SN', label: 'Sénégal' }, // Senegal in French
    { code: 'SO', label: 'Soomaaliya' }, // Somalia in Somali
    { code: 'SR', label: 'Suriname' },
    { code: 'SS', label: 'South Sudan' },
    { code: 'ST', label: 'São Tomé e Príncipe' }, // Sao Tome and Principe in Portuguese
    { code: 'SV', label: 'El Salvador' },
    { code: 'SX', label: 'Sint Maarten' },
    { code: 'SY', label: 'سوريا' }, // Syria in Arabic
    { code: 'SZ', label: 'eSwatini' }, // Swaziland in Swazi
    { code: 'TC', label: 'Turks and Caicos Islands' },
    { code: 'TD', label: 'Tchad' }, // Chad in French
    { code: 'TF', label: 'Terres australes et antarctiques françaises' }, // French Southern Territories in French
    { code: 'TG', label: 'Togo' },
    { code: 'TH', label: 'ประเทศไทย' }, // Thailand in Thai
    { code: 'TJ', label: 'Тоҷикистон' }, // Tajikistan in Tajik
    { code: 'TK', label: 'Tokelau' },
    { code: 'TL', label: 'Timor-Leste' },
    { code: 'TM', label: 'Türkmenistan' }, // Turkmenistan in Turkmen
    { code: 'TN', label: 'تونس' }, // Tunisia in Arabic
    { code: 'TO', label: 'Tonga' },
    { code: 'TR', label: 'Türkiye' }, // Turkey in Turkish
    { code: 'TT', label: 'Trinidad and Tobago' },
    { code: 'TV', label: 'Tuvalu' },
    { code: 'TW', label: '台灣' }, // Taiwan in Chinese
    { code: 'TZ', label: 'Tanzania' },
    { code: 'UA', label: 'Україна' }, // Ukraine in Ukrainian
    { code: 'UG', label: 'Uganda' },
    { code: 'US', label: 'United States' },
    { code: 'UY', label: 'Uruguay' },
    { code: 'UZ', label: 'Oʻzbekiston' }, // Uzbekistan in Uzbek
    { code: 'VA', label: 'Città del Vaticano' }, // Vatican City in Italian
    { code: 'VC', label: 'Saint Vincent and the Grenadines' },
    { code: 'VE', label: 'Venezuela' },
    { code: 'VG', label: 'British Virgin Islands' },
    { code: 'VI', label: 'U.S. Virgin Islands' },
    { code: 'VN', label: 'Việt Nam' }, // Vietnam in Vietnamese
    { code: 'VU', label: 'Vanuatu' },
    { code: 'WF', label: 'Wallis-et-Futuna' }, // Wallis and Futuna in French
    { code: 'WS', label: 'Samoa' },
    { code: 'XK', label: 'Kosovë' }, // Kosovo in Albanian
    { code: 'YE', label: 'اليمن' }, // Yemen in Arabic
    { code: 'YT', label: 'Mayotte' },
    { code: 'ZA', label: 'South Africa' },
    { code: 'ZM', label: 'Zambia' },
    { code: 'ZW', label: 'Zimbabwe' }
]
